import React from "react";

import classNames from "classnames";
import styles from "../../styles/new-search-widget.module.scss";
import {EntityLogo, EntityLogoProps} from "../../../../core/components/logos/entity-logo";
import {NewSearchWidgetEntitiesItemInfo} from "./new-search-widget.entities.item-info";
import {Link} from "../../../../core/components/link/link";
import {NEW_SEARCH_WIDGET} from "../../new-search-widget.consts";
import {IntersectionObserver} from "../../../../core/components/intersection-observer/intersection-observer";
import {NewSearchWidgetEntityKeyboardClickComposer} from "../../composers/new-search-widget.entity-keyboard-click.composer";

export const NewSearchWidgetEntitiesItem = NewSearchWidgetEntityKeyboardClickComposer(({controller, entity, isRecentSearchesList, listModel, isHighlighted, onMouseEnter, index}) => {
  const linkProps = {
    className: classNames(styles.entity_item_intersection),
    model: entity.linkModel,
    onClick: () => controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.entityClickHandler, {item: entity, subSource: listModel?.id})
  }

  const logoProps: EntityLogoProps = {
    className: classNames(styles.entity_item_logo),
    entity,
    width: 32,
    height: 32,
  }

  const infoProps = {
    controller,
    entity,
    isRecentSearchesList
  }

  const itemProps = {
    onMouseEnter: () => onMouseEnter?.(index, listModel.id),
    className: classNames(styles.entity_item, {[styles.item_hover]: isHighlighted}, {"highlighted_item": isHighlighted}),
    keepObserving: true
  }

  return (
    <IntersectionObserver {...itemProps}>
      <Link {...linkProps}>
        <EntityLogo {...logoProps}/>
        <NewSearchWidgetEntitiesItemInfo {...infoProps}/>
      </Link>
    </IntersectionObserver>
  )
});
